import { useBrandStore } from "src/stores/brand-store";

import { notUndefined } from "../utils";

export const useBrand = () => {
  const brand = useBrandStore((state) => state.brand);

  return notUndefined(brand);
};
